import "styles/pages/page-single-offer.scss";
import React, { useState, useEffect, useRef } from "react";
import { graphql } from "gatsby";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import OfferMainInfo from "components/OfferMainInfo/OfferMainInfo";
import classNames from "classnames";
import Slider from "react-slick";
import TeamDropdownMenu from "components/TeamDropdownMenu/TeamDropdownMenu";
import FeaturedOffersSlider from "components/FeaturedOffersSlider/FeaturedOffersSlider";
import ContactForm from "components/ContactForm/ContactForm";
import { addSpaceInNumbers } from "../utils";

const OfferPage = ({ pageContext, data }) => {
	const vehicleType = pageContext.vehicleType.vehicleType;
	const [sliderState, setSliderState] = useState({
		nav1: null,
		nav2: null,
	});
	const [photoIndex, setPhotoIndex] = useState(0);
	const [isLightboxOpen, setIsLightboxOpen] = useState(false);
	const advisorTeam = data.commercialAdvisorTeam.edges;
	const featuredTrailers = data.allWpTrailer.edges;
	const featuredVehicles = data.allWpVehicle.edges;
	const [slideIndex, setSlideIndex] = useState(1);
	const vehicleInfo = pageContext.pageContent;
	const seo = pageContext.seo;
	const slider1 = useRef();
	const slider2 = useRef();
	const { nav1, nav2 } = sliderState;
	const gallery = vehicleInfo.gallery?.map((item) => item.sourceUrl);
	useEffect(() => {
		setSliderState({
			nav1: slider1.current,
			nav2: slider2.current,
		});
	}, []);

	const mainGallerySlider = {
		dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		draggable: true,
		autoplay: false,
		beforeChange: (current) => setSlideIndex(current + 1),
		afterChange: (current) => setSlideIndex(current + 1),
	};

	const galleryNavSlider = {
		dots: false,
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: true,
		draggable: true,
		responsive: [
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 420,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 340,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	};

	return (
		<Layout>
			<Seo title={seo.title} description={seo.metaDesc} />
			<SubpageHeader
				crumbFirstLabel="pojazdy kempingowe"
				crumbSecondLabel="pojazdy dostępne od ręki"
				crumbSecondLink="/pojazdy-dostepne-od-reki"
				location={pageContext.title}
			/>
			<section className="offer-info">
				<div className="container">
					<div className="row">
						<div className="col-lg-7">
							<div className="gallery-container">
								<div className="gallery-container__main-slider">
									<Slider
										{...mainGallerySlider}
										asNavFor={nav2}
										ref={(slider) =>
											(slider1.current = slider)
										}
									>
										{vehicleInfo.gallery?.map(
											(node, index) => {
												return (
													<div
														key={index}
														style={{
															position:
																"relative",
														}}
													>
														<div
															className="gallery-container__main-single-slide"
															style={{
																backgroundImage: `url(${node.sourceUrl})`,
															}}
															onClick={(e) => {
																e.preventDefault();
																setIsLightboxOpen(
																	true
																);
																setPhotoIndex(
																	index
																);
															}}
															aria-hidden="true"
														>
															<div
																className="gallery-container__zoom-icon"
																onClick={(
																	e
																) => {
																	e.preventDefault();
																	setIsLightboxOpen(
																		true
																	);
																	setPhotoIndex(
																		index
																	);
																}}
																aria-hidden="true"
															/>
														</div>
													</div>
												);
											}
										)}
									</Slider>
									<div className="gallery-container__slides-counter">
										<img
											src={
												require("assets/icons/gallery-count.svg")
													.default
											}
											alt=""
										/>
										{slideIndex}/
										{vehicleInfo.gallery?.length}
									</div>
								</div>
								<div className="gallery-container__nav-slider">
									<Slider
										{...galleryNavSlider}
										asNavFor={nav1}
										ref={(slider) =>
											(slider2.current = slider)
										}
										swipeToSlide={false}
										focusOnSelect={true}
									>
										{vehicleInfo.gallery?.map(
											(node, index) => {
												return (
													<div key={index}>
														<div
															className="gallery-container__nav-single-slide"
															style={{
																backgroundImage: `url(${node.sourceUrl})`,
															}}
														/>
													</div>
												);
											}
										)}
									</Slider>
								</div>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="type-info">
								<div
									className={classNames(
										"type-info__single-item",
										{
											[`type-info__single-item--active`]:
												vehicleInfo.type[0] ===
												"kampervan",
										}
									)}
								>
									kamper-van
								</div>
								<div
									className={classNames(
										"type-info__single-item",
										{
											[`type-info__single-item--active`]:
												vehicleInfo.type[0] ===
												"polintegra",
										}
									)}
								>
									półintegra
								</div>
								<div
									className={classNames(
										"type-info__single-item",
										{
											[`type-info__single-item--active`]:
												vehicleInfo.type[0] ===
												"integra",
										}
									)}
								>
									integra
								</div>
								<div
									className={classNames(
										"type-info__single-item",
										{
											[`type-info__single-item--active`]:
												vehicleInfo.type[0] ===
												"przyczepa",
										}
									)}
								>
									przyczepa
								</div>
							</div>
							<h2 className="offer-info__title">
								{vehicleInfo.name}
							</h2>
							{vehicleInfo.type[0] !== "przyczepa" ? (
								<div className="main-info">
									<OfferMainInfo
										label="dł."
										info={vehicleInfo.length}
										secondLabel="szer."
										secondInfo={vehicleInfo.width}
										thirdLabel="wys."
										thirdInfo={vehicleInfo.height}
										divider="|"
										sufix="cm"
									/>
									<OfferMainInfo
										label="pojazd bazowy"
										info={vehicleInfo.mainVehicle}
									/>
									<OfferMainInfo
										label="silnik"
										info={vehicleInfo.engine}
										secondLabel="moc"
										secondInfo={vehicleInfo.enginePorwer}
										divider=","
										sufix="cm3"
										secondSufix="km"
									/>
									<OfferMainInfo
										label="przebieg"
										info={vehicleInfo.mileage}
										iconText="pojazd demonstracyjny"
										sufix="km"
									/>
									<OfferMainInfo
										label="skrzynia biegów"
										info={vehicleInfo.gearbox}
									/>
									<OfferMainInfo
										label="miejsca do jazdy"
										info={vehicleInfo.ridePlaces}
										divider="|"
										secondLabel="miejsca do spania"
										secondInfo={vehicleInfo.sleepingPlaces}
									/>
									<OfferMainInfo
										label="dopuszczalna masa całkowita (dmc)"
										info={vehicleInfo.dmc}
										sufix="kg"
									/>
									<OfferMainInfo
										label="masa w gotowości do jazdy"
										info={vehicleInfo.readyWeight}
										iconText={
											vehicleInfo.readyWeigthIconText
										}
										sufix="kg"
									/>
									<OfferMainInfo
										label="wersja zimowa"
										info={true}
										choice={vehicleInfo.winterVersion}
									/>
									<OfferMainInfo
										label="pojemnośc lodówki"
										info={`${vehicleInfo.refrigeratorCapacity} l`}
									/>
									<OfferMainInfo
										label="zbiornik na wodę czystą / szarą"
										info={`${
											vehicleInfo.clearWaterCapacity
												? `${vehicleInfo.clearWaterCapacity} l`
												: "--"
										} / ${
											vehicleInfo.dirtyWaterCapacity
												? `${vehicleInfo.dirtyWaterCapacity} l`
												: "--"
										}`}
									/>
									<OfferMainInfo
										label="ogrzewanie"
										info={vehicleInfo.heatSystem}
									/>
								</div>
							) : (
								<div className="main-info">
									<OfferMainInfo
										label="długość z dyszlem"
										info={vehicleInfo.lengthWithDrawbar}
										secondLabel="dł. wew"
										secondInfo={vehicleInfo.lengthInside}
										divider="|"
										sufix="cm"
									/>
									<OfferMainInfo
										label="szer. całkowita"
										info={vehicleInfo.fullWidth}
										secondLabel="szer. wew."
										secondInfo={vehicleInfo.widthInside}
										divider="|"
										sufix="cm"
									/>
									<OfferMainInfo
										label="wys. całkowita"
										info={vehicleInfo.heightFull}
										secondLabel="wys. wewnątrz"
										secondInfo={vehicleInfo.heightInside}
										divider="|"
										sufix="cm"
									/>
									<OfferMainInfo
										label="rok produkcji"
										info={vehicleInfo.yearOfProduction}
									/>
									<OfferMainInfo
										label="miejsca do spania"
										info={vehicleInfo.sleepingPlaces}
									/>
									<OfferMainInfo
										label="dopuszczalna masa całkowita (DMC)"
										info={vehicleInfo.dmc}
										sufix="kg"
									/>
									<OfferMainInfo
										label="masa w gotowości do jazdy"
										info={vehicleInfo.readyWeight}
										iconText={
											vehicleInfo.readyWeigthIconText
										}
										sufix="kg"
									/>
									<OfferMainInfo
										label="ładowność"
										info={vehicleInfo.loadingCapacity}
										sufix="kg"
									/>
									<OfferMainInfo
										label="liczba osi"
										info={vehicleInfo.axes}
									/>
									<OfferMainInfo
										label="typ ramy"
										info={vehicleInfo.frameType}
									/>
									<OfferMainInfo
										label="wersja zimowa"
										info={vehicleInfo.winterVersion}
										choice={true}
									/>
									<OfferMainInfo
										label="pojemnośc lodówki"
										info={vehicleInfo.refrigeratorCapacity}
										sufix="l"
									/>
									<OfferMainInfo
										label="zbiornik na wodę czystą"
										info={vehicleInfo.clearWaterCapacity}
										sufix="l"
									/>
									<OfferMainInfo
										label="ogrzewanie"
										info={vehicleInfo.heatSystem}
									/>
								</div>
							)}
							<div className="main-info__price-container">
								<div className="main-info__price-label">
									Cena całkowita w PLN (brutto):
								</div>
								<div className="main-info__price">
									{vehicleInfo.discount === true
										? addSpaceInNumbers(
												vehicleInfo.priceDiscount
										  )
										: addSpaceInNumbers(
												vehicleInfo.price
										  )}{" "}
									zł
								</div>
								{vehicleInfo.discount && (
									<div className="main-info__price--sale">
										{addSpaceInNumbers(vehicleInfo.price)}{" "}
										zł
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="text-container">
								<h3 className="text-container__title">Opis</h3>
								<div
									className="text-container__content"
									dangerouslySetInnerHTML={{
										__html: vehicleInfo.description,
									}}
								/>
							</div>
							{vehicleType === "trailer" && (
								<div className="text-container">
									<h3 className="text-container__title">
										Wyposażenie
									</h3>
									<div
										className="text-container__content"
										dangerouslySetInnerHTML={{
											__html: vehicleInfo.equipment,
										}}
									/>
								</div>
							)}
							{vehicleType === "vehicle" && (
								<>
									<div className="text-container">
										<h3 className="text-container__title">
											Wyposażenie pojazdu bazowego
										</h3>
										<div
											className="text-container__content"
											dangerouslySetInnerHTML={{
												__html: vehicleInfo.mainVehicleEquipment,
											}}
										/>
									</div>
									<div className="text-container">
										<h3 className="text-container__title">
											Wyposażenie części mieszkalnej
										</h3>
										<div
											className="text-container__content"
											dangerouslySetInnerHTML={{
												__html: vehicleInfo.livingSpaceEquipment,
											}}
										/>
									</div>
								</>
							)}
						</div>
						<div className="col-lg-5">
							<div className="main-info__question-container">
								<img
									src={
										require("assets/icons/offer-question.svg")
											.default
									}
									alt=""
									className="main-info__question-icon"
								/>
								<div className="main-info__question-text">
									Masz pytania? Chcesz dowiedzieć się więcej?
									<br />
									<a href="#kontakt">
										Wyślij wiadomość do naszego doradcy!
									</a>
								</div>
							</div>
							<TeamDropdownMenu team={advisorTeam} />
							<h3 className="offer-info__block-title">
								Rzuty (dzień/noc)
							</h3>
							<div className="projections">
								<div className="row">
									<div className="col-sm-6">
										<div className="projections__icon-container">
											<img
												src={
													require("assets/icons/sun.png")
														.default
												}
												alt=""
												className="projections__icon"
											/>
										</div>
										<div
											className="projections__single-projection"
											style={{
												backgroundImage: `url(${vehicleInfo.projectionDay?.sourceUrl})`,
											}}
										/>
									</div>
									<div className="col-sm-6">
										<div className="projections__icon-container">
											<img
												src={
													require("assets/icons/moon.png")
														.default
												}
												alt=""
												className="projections__icon projections__icon--moon"
											/>
										</div>
										<div
											className="projections__single-projection"
											style={{
												backgroundImage: `url(${vehicleInfo.projectionNight?.sourceUrl})`,
											}}
										/>
									</div>
								</div>
							</div>
							<h3 className="offer-info__block-title">
								Więcej informacji
							</h3>
							<div className="more-info">
								{vehicleInfo.pdfCatalog && (
									<a
										href={
											vehicleInfo.pdfCatalog?.localFile
												?.publicURL
										}
										className="more-info__single-item"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src={
												require("assets/icons/pdf.svg")
													.default
											}
											alt=""
											className="more-info__icon img-fluid"
										/>
										pobierz <br />
										katalog .pdf
									</a>
								)}
								{vehicleInfo.producentWebstie && (
									<a
										href={vehicleInfo.producentWebstie}
										target="_blank"
										rel="noreferrer"
										className="more-info__single-item"
									>
										<img
											src={
												require("assets/icons/website.svg")
													.default
											}
											alt=""
											className="more-info__icon img-fluid"
										/>
										informacje o tym modelu <br /> na
										stronie producenta
									</a>
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="other-offers">
				<div className="container">
					<FeaturedOffersSlider
						trailers={featuredTrailers}
						vehicles={featuredVehicles}
					/>
				</div>
			</section>
			<section className="offer-contact">
				<span className="anchor" id="kontakt"></span>
				<ContactForm subject={`sprzedaż: ${vehicleInfo.name}`} />
			</section>
			{isLightboxOpen && (
				<Lightbox
					mainSrc={gallery[photoIndex]}
					nextSrc={gallery[(photoIndex + 1) % gallery.length]}
					prevSrc={
						gallery[
							(photoIndex + gallery.length - 1) % gallery.length
						]
					}
					onCloseRequest={() => setIsLightboxOpen(false)}
					onMovePrevRequest={() =>
						setPhotoIndex(
							(photoIndex + gallery.length - 1) % gallery.length
						)
					}
					onMoveNextRequest={() =>
						setPhotoIndex((photoIndex + 1) % gallery.length)
					}
				/>
			)}
		</Layout>
	);
};

export const query = graphql`
	query {
		commercialAdvisorTeam: allWpTeam(
			filter: { singleTeam: { commercialAdvisorTeam: { eq: "true" } } }
		) {
			edges {
				node {
					singleTeam {
						commercialAdvisorTeam
						email
						fullname
						jobname
						phone
						avatar {
							sourceUrl
						}
					}
				}
			}
		}
		allWpTrailer(
			filter: { vehicles: { groupOrSingle: { eq: "single" } } }
		) {
			edges {
				node {
					vehicles {
						price
						priceDiscount
						name
						tileImg {
							sourceUrl
						}
						gallery {
							sourceUrl
						}
					}
					slug
					uri
				}
			}
		}
		allWpVehicle(
			filter: { vehicles: { groupOrSingle: { eq: "single" } } }
		) {
			edges {
				node {
					vehicles {
						price
						priceDiscount
						name
						tileImg {
							sourceUrl
						}
						gallery {
							sourceUrl
						}
					}
					slug
					uri
				}
			}
		}
	}
`;

export default OfferPage;
